import React, { useEffect, useState } from 'react';
import { Input } from '../../components/ui/Input'
import LayoutDashBoard from '../../components/layoutDashBoard/LayoutDashBoard';
import { useNavigate } from 'react-router-dom';
import { useProduct } from '../../context/ProductSelectedContext';
import { IoMdArrowBack } from "react-icons/io";
import { GetServiceEntities } from '../../service/controller/BMGDadosMestres';
import { useService } from '../../context/ServiceSelectedContext';

export default function Dashboard() {
    const { setProductSelected } = useProduct();
    const { setServiceSelected } = useService();
    const navigate = useNavigate();
    const [search, setSearch] = useState('');
    const [availableBenefits, setAvailableBenefits] = useState([]);
    const [services, setServices] = useState([]);

    useEffect(() => {
        GetServiceEntities(entities => setAvailableBenefits(entities));
    }, [])

    const goTo = (entityDesc) => {
        if (!entityDesc.toLocaleLowerCase().includes('cart')) {
            navigate('/dashboard/loan')
            return;
        }
        if (entityDesc == 'Cartão Benefício INSS') {
            navigate('/dashboard/benefit-card')
            return;
        }
        if (entityDesc == 'Cartão BMG Master INSS') {
            navigate('/dashboard/master-card')
            return;
        }
        if (entityDesc == 'Cartão Outros Convênios') {
            navigate('/dashboard/bmg-card')
            return;
        }
    }

    const getImageCard = (entityDesc) => {
        if (entityDesc == 'Empréstimos')
            return '/assets/emprestimo.png'
        if (entityDesc.includes('Empréstimos'))
            return '/assets/emprestimo.png'
        if (entityDesc.includes('Cartões'))
            return '/assets/mulher-segurando-cartao.png'
        if (entityDesc.includes('Cartão Benefício'))
            return '/assets/mulher-segurando-cartao.png'
        if (entityDesc.includes('Cartão BMG Master'))
            return '/assets/mulher-segurando-cartao_2.png'
        if (entityDesc.includes('Cartão Consignado'))
            return '/assets/cartoes-bmg-2.png'
        if (entityDesc.includes('Cartões'))
            return '/assets/cartoes-bmg-2.png'
        if (entityDesc.includes('Entidade Especial'))
            return '/assets/entidade.png'
        if (entityDesc.includes('INSS'))
            return '/assets/INSS.png'
        return '/assets/mulher-segurando-cartao_2.png'
    }

    return (
        <LayoutDashBoard activeMenu={'Home'}>
            {services.length === 0 && <div>
                <h2 className="font-semibold text-lg">Produtos disponíveis</h2>
                <p className="text-sm text-gray-500">Aqui você vê suas oportunidades</p>
                <div className="mt-6">
                    <Input placeholder='Buscar Produto' value={search} onChange={e => setSearch(e.target.value)} />
                    <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                        {availableBenefits
                            .filter(x => x.nomeEntidade?.toLowerCase()?.includes(search.toLowerCase()))
                            .map((benefit, idx) => (
                                <div
                                    key={idx}
                                    className="bg-white rounded-2xl p-6 mt-4 shadow-lg flex flex-col justify-between hover:shadow-xl transition-shadow duration-300"
                                >
                                    <div>
                                        <div className="flex items-center mb-4">
                                            <div className="w-4 h-4 bg-[#FA6300] rounded-full mr-4"></div>
                                            <h3 className="font-semibold text-lg">{benefit.nomeEntidade}</h3>
                                        </div>
                                        <div className="flex items-center justify-center">
                                            <img className='h-[250px]' src={getImageCard(benefit.nomeEntidade)} alt="" />
                                        </div>
                                    </div>
                                    <button onClick={() => setServices(benefit.servicos)} className="bg-[#FA6300] text-white py-2 px-3 rounded-full font-semibold w-full hover:bg-[#e55a00] transition-colors duration-300">
                                        Ver Produtos
                                    </button>
                                </div>
                            ))}
                    </div>
                </div>
                {availableBenefits.length === 0 && <span className='text-sm text-gray-400'>Nenhum produto disponivel :(</span>}
            </div>}

            {services.length > 0 && <React.Fragment>
                <button className='flex items-center gap-3' onClick={() => setServices([])}><IoMdArrowBack /> Voltar Para Produtos</button>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    {services
                        .filter(x => x.nomeServico.toLowerCase()?.includes(search.toLowerCase()))
                        .map((page, idx) => (
                            <div key={idx} className="bg-white rounded-xl p-6 shadow-md flex flex-col justify-between">
                                <div>
                                    <div className="flex items-center mb-4">
                                        <div className="bg-[#FA6300] text-white rounded-full p-2 mr-4">
                                            {/* {page.icon} */}
                                        </div>
                                        <h3 className="font-semibold">{page.nomeServico}</h3>
                                    </div>
                                    <p className="text-sm text-gray-500 mb-6">{page.descricaoEntidade}</p>
                                    <div className="flex items-center justify-center">
                                        <img className='h-[250px]' src={getImageCard(page.nomeServico)} alt="" />
                                    </div>
                                </div>
                                <button onClick={() => { setProductSelected(page.codigoProduto); setServiceSelected(page.codigoServico); goTo(page.nomeServico) }} className="bg-[#FA6300] text-white py-2 px-4 rounded-full font-semibold">
                                    Solicitar Agora
                                </button>
                            </div>
                        ))}
                </div>
            </React.Fragment>}

        </LayoutDashBoard >
    );
}
